<script setup lang="ts">
import BaseActionMenu from '@/components/base/menus/BaseActionMenu.vue'
import { useActions } from '@/core/composables/useActions'
import { toRef } from 'vue'

interface Props {
  /** The actionable object with actions */
  actionable: HasActionsInterface
  /** Options for action configuration */
  options?: ActionOptions
}

const { actionable, options = { labelPath: 'general' } } = defineProps<Props>()

defineOptions({
  name: 'ActionMenu'
})

const { mappedActions: actions } = useActions(
  toRef(() => actionable),
  toRef(() => options)
)
</script>

<template>
  <BaseActionMenu :actions />
</template>
